export const state = {
  // Maps keyed by orgId, fetched from the backend.
  // Map = { id (uuid), map_id, name, isDefault, color, icon, basemap, visible, shared, layerCodes: string[] }
  // `basemap` is a key into the BASEMAPS catalog (see components/maps/basemaps.ts).
  maps: {},
  // Per-map member rosters, keyed by mapId (the map uuid).
  // MapMember = { map_member_id, map_id, member_id, role_name, email,
  //   display_name, first_name, last_name, avatar_url, verified, create_dttm }
  members: {},
  // Per-map pending invites, keyed by mapId.
  // MapInvite = { id, uuid, fullname, first_name, last_name, email, phone,
  //   map_id, map_role, inviter_id, is_accepted, created_at, email_status }
  invites: {}
}
